var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("SidebarWidget", {
    attrs: {
      title: _vm.$gettext("Farbe"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c("studip-select", {
              attrs: {
                multiple: "",
                options: _vm.selectableColors,
                label: "name",
              },
              on: {
                input: _vm.onVueSelectInput,
              },
              scopedSlots: _vm._u([
                {
                  key: "open-indicator",
                  fn: function fn() {
                    return [
                      _c(
                        "span",
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "arr_1down",
                              size: 10,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "option",
                  fn: function fn(_ref) {
                    var name = _ref.name,
                      hex = _ref.hex
                    return [
                      _c("span", {
                        staticClass: "vs__option-color",
                        style: {
                          "background-color": hex,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(name))]),
                    ]
                  },
                },
                {
                  key: "selected-option",
                  fn: function fn(_ref2) {
                    var name = _ref2.name,
                      hex = _ref2.hex
                    return [
                      _c("span", {
                        staticClass: "vs__option-color",
                        style: {
                          "background-color": hex,
                        },
                        attrs: {
                          title: name,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "no-options",
                  fn: function fn() {
                    return [
                      _vm._v(
                        _vm._s(_vm.$gettext("Keine Auswahlmöglichkeiten"))
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.selectedColors,
                callback: function callback($$v) {
                  _vm.selectedColors = $$v
                },
                expression: "selectedColors",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }